module.exports = require('./opt')
module.exports.boolean = require('./boolean')
module.exports.hash = require('./hash')
module.exports.list = require('./list')
module.exports.number = require('./number')
module.exports.opt = require('./opt')
module.exports.string = require('./string')
